<template lang='pug'>
  div(@click='toLecture').wrap-item-card-lecture.pt12.pb10
    div.wrap-card-content
      div.wrap-title.f.fm.flex-between.mb2
        div.f.fm
          span.card-title {{content.title}}
        //- div.f.fm
        //-   v-icon(size='18px' color='#999').mr2 query_builder
        //-   span.time.pt1 {{content.time}}
      div.wrap-comment.mb2
        span.comment.line-clamp-1 {{content.comment}}
      div.f.flex-between
        div.wrap-report-info.f.fm
          div.wrap-check-icon.f.fm
            v-icon(v-if="report && report.status == 'pass'" color='blue' size='20px').mr2 check_circle
            v-icon(v-if="report && report.status == 'fail'" color='red' size='20px').mr2 remove_circle
            //- v-icon(v-else color='#999' size='20px').mr2 radio_button_unchecked
          span レポート：
          span(v-if="report && report.status == 'reviewing'") 提出済み | レヴュー中
          span(v-if="report && report.status == 'pass'") 提出済み | 合格
          span(v-if="report && report.status == 'fail'") 提出済み | 再提出
          span(v-if="!report") 未提出
        div.f.fm
          v-icon(size='18px' color='#999').mr2 query_builder
          span.time.pt1 {{content.time}}
</template>

<style lang='scss' scoped>
.wrap-item-card-lecture {
  border-bottom: solid 0.6px rgba(0, 0, 0, 0.4);
  .wrap-card-content {
    width: 93%;
    margin: 0 auto;
    max-width: 820px;
    .wrap-title {
      .card-title {
        font-size: 16px;
        font-weight: bold;
      }
      .time {
        font-size: 12px;
        color: #999;
      }
    }
    .wrap-report-info {
      span {
        font-size: 12px;
      }
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'

import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { database } from '@shared/database'

export default {
  components: {
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    content: {
      type: Object,
      required: true
    },
    isSubscribed: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      report: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    // db.collection('REPORTS')
    //   .where('createdBy', '==', this.uid)
    //   .where('course', '==', this.$route.params.id)
    //   .where('lectureIndex', '==', this.index.toString())
    //   .onSnapshot(this.handleReport)
    database.onReportsUpdated({
      createdBy: this.uid,
      course: this.$route.params.id,
      lectureIndex: this.index.toString(),
    }, this.handleReport)
  },
  methods: {
    toLecture () {
      // TODO LamDV
      // if (this.isSubscribed) {
      //   this.$router.push(`/course/${this.$route.params.id}/${this.content.num}`)
      //   gtag('send', 'click', {event_category: 'lecture_list', event_label: 'click list in lecture_list'})
      // } else {
      //   this.$emit('showModalWindow')
      //   gtag('send', 'click', {event_category: 'lecture_list', 'event_label': 'click list in lecture_list without payment'})
      // }
    },
    handleReport (reports) {
      if (reports.length > 0) {
        this.report = reports[0]
      }
    }
  }
}
</script>
